// Duquesne University's undergraduate majors (#2743). Read on 2026-10-01 from
// the official 2026-2027 Undergraduate Catalog's Academic Programs page
// ("Degree Programs Offered by Duquesne University", which leaves out dual
// degrees, minors, concentrations and certificates). Every entry in its
// Bachelor's column is kept, one line per degree where a program lists two
// (Computer Science BA and BS, ...). Left out: Business and Law 3/3
// (BSBA/JD), a dual degree. Group names are the catalog's own; degree
// abbreviations are as the catalog writes them. The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "duquesne-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Duquesne's official 2026-2027 Undergraduate Catalog, grouped by the school that offers it, with the degree it leads to. Minors, concentrations, certificates, dual degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "College & Graduate School of Liberal Arts",
            "source": {
                "label": "Duquesne 2026-2027 Undergraduate Catalog, Degree Programs Offered",
                "url": "https://www.duq.edu/academics/university-catalogs/2026-2027-catalog/undergraduate/academic-programs/index.php"
            },
            "majors": [
                {
                    "name": "Catholic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Corporate Communication",
                    "degree": "BA"
                },
                {
                    "name": "Cybersecurity Studies",
                    "degree": "BA"
                },
                {
                    "name": "Digital Media Arts",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Integrated Marketing Communication",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "International Security Studies",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Arts",
                    "degree": "BA"
                },
                {
                    "name": "Multiplatform Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations and Advertising",
                    "degree": "BA"
                },
                {
                    "name": "Rhetoric",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Sports Information and Media",
                    "degree": "BA"
                },
                {
                    "name": "Theater Arts",
                    "degree": "BA"
                },
                {
                    "name": "Theology",
                    "degree": "BA"
                },
                {
                    "name": "Women's & Gender Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Business Administration",
            "source": {
                "label": "Duquesne 2026-2027 Undergraduate Catalog, Degree Programs Offered",
                "url": "https://www.duq.edu/academics/university-catalogs/2026-2027-catalog/undergraduate/academic-programs/index.php"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Analytics (co-major)",
                    "degree": "BSBA",
                    "note": "A co-major, taken together with another business major."
                },
                {
                    "name": "Economics",
                    "degree": "BSBA"
                },
                {
                    "name": "Entrepreneurship & Innovation",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance - Financial Planning",
                    "degree": "BSBA"
                },
                {
                    "name": "General Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Information Systems and Technology",
                    "degree": "BSBA"
                },
                {
                    "name": "Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BSBA"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Duquesne 2026-2027 Undergraduate Catalog, Degree Programs Offered",
                "url": "https://www.duq.edu/academics/university-catalogs/2026-2027-catalog/undergraduate/academic-programs/index.php"
            },
            "majors": [
                {
                    "name": "Early Childhood Education (PreK-4)",
                    "degree": "BSEd"
                },
                {
                    "name": "Middle Level (4-8)",
                    "degree": "BSEd"
                },
                {
                    "name": "Secondary Education (7-12) English",
                    "degree": "BSEd"
                },
                {
                    "name": "Secondary Education (7-12) Mathematics",
                    "degree": "BSEd"
                },
                {
                    "name": "Secondary Education (7-12) Social Studies",
                    "degree": "BSEd"
                }
            ]
        },
        {
            "name": "School of Health Sciences",
            "source": {
                "label": "Duquesne 2026-2027 Undergraduate Catalog, Degree Programs Offered",
                "url": "https://www.duq.edu/academics/university-catalogs/2026-2027-catalog/undergraduate/academic-programs/index.php"
            },
            "majors": [
                {
                    "name": "Athletic Training",
                    "degree": "BSHS/MSAT",
                    "note": "A combined bachelor's and master's program."
                },
                {
                    "name": "Health Administration",
                    "degree": "BSHA"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BSHS"
                },
                {
                    "name": "Public Health",
                    "degree": "BAPH"
                },
                {
                    "name": "Public Health",
                    "degree": "BSPH"
                }
            ]
        },
        {
            "name": "School of Music",
            "source": {
                "label": "Duquesne 2026-2027 Undergraduate Catalog, Degree Programs Offered",
                "url": "https://www.duq.edu/academics/university-catalogs/2026-2027-catalog/undergraduate/academic-programs/index.php"
            },
            "majors": [
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Education",
                    "degree": "BSME"
                },
                {
                    "name": "Music Technology",
                    "degree": "BM"
                },
                {
                    "name": "Music Therapy",
                    "degree": "BSMT"
                },
                {
                    "name": "Performance",
                    "degree": "BM"
                }
            ]
        },
        {
            "name": "School of Science and Engineering",
            "source": {
                "label": "Duquesne 2026-2027 Undergraduate Catalog, Degree Programs Offered",
                "url": "https://www.duq.edu/academics/university-catalogs/2026-2027-catalog/undergraduate/academic-programs/index.php"
            },
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "General Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "Duquesne 2026-2027 Undergraduate Catalog, Degree Programs Offered",
                "url": "https://www.duq.edu/academics/university-catalogs/2026-2027-catalog/undergraduate/academic-programs/index.php"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Second Degree Nursing",
                    "degree": "BSN",
                    "note": "For students who already hold a bachelor's degree."
                }
            ]
        },
        {
            "name": "School of Pharmacy",
            "source": {
                "label": "Duquesne 2026-2027 Undergraduate Catalog, Degree Programs Offered",
                "url": "https://www.duq.edu/academics/university-catalogs/2026-2027-catalog/undergraduate/academic-programs/index.php"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
